module.exports = __webpack_public_path__ + "static/media/bookmark4.84789c1a.png";